module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-300italic.37c74a8d.woff";